window.lazySizesConfig = {
    lazyClass: 'lazyload',
    preloadAfterLoad: true,
    addClasses: true,
    expFactor: 1.5,
    loadMode: 2,
};
